// Ortak biçimlendirme ve durum yardımcıları.

export const ONAY_DURUMU = {
  BEKLIYOR: 1,
  ONAYLANDI: 2,
  REDDEDILDI: 3,
};

export function durumEtiketSinifi(onayDurumu) {
  switch (Number(onayDurumu)) {
    case ONAY_DURUMU.ONAYLANDI:
      return 'status-onayladi';
    case ONAY_DURUMU.REDDEDILDI:
      return 'status-reddedildi';
    default:
      return 'status-beklemede';
  }
}

export function durumAdi(onayDurumu, verilen) {
  if (verilen) return verilen;
  switch (Number(onayDurumu)) {
    case ONAY_DURUMU.ONAYLANDI:
      return 'Onaylandı';
    case ONAY_DURUMU.REDDEDILDI:
      return 'Reddedildi';
    default:
      return 'Bekliyor';
  }
}

export function tarih(deger) {
  if (!deger) return '-';
  const d = new Date(deger);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('tr-TR');
}

export function tarihSaat(deger) {
  if (!deger) return '-';
  const d = new Date(deger);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' });
}
